import styled from 'styled-components';

const Show = styled.div.withConfig({
  shouldForwardProp: (props) => {
    return !['show'].includes(props);
  },
})<{ show: boolean }>`
  display: ${(props) => (props.show ? 'block' : 'none')};
`;
export default Show;
